import { render, staticRenderFns } from "./MockRecord.vue?vue&type=template&id=da5186dc&scoped=true"
import script from "./MockRecord.vue?vue&type=script&lang=js"
export * from "./MockRecord.vue?vue&type=script&lang=js"
import style0 from "./MockRecord.vue?vue&type=style&index=0&id=da5186dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5186dc",
  null
  
)

export default component.exports